import React from "react";
import "./index.css";
import FormComponent from "../FormComponent";
import { siteContent } from "../content";

const Hero = () => {

  return (
    <>

      <div className="fullH">
        <div className="container-lg">
          <div className="heroBox flex flexRow">
            <div className="textCol">
              <h4 className="relative">{siteContent.hero.eyebrow}</h4>
              <h1 className="relative">
                {siteContent.hero.title}
              </h1>
              <h3 className="relative">
                {siteContent.hero.description}
              </h3>
              <a
                href="#form"
                className="btn whitebtn"
              >
                {siteContent.hero.cta}
              </a>
            </div>
            <div className="formCol">
              <FormComponent />
            </div>
          </div>

        </div>
      </div>
      <div className="container-lg">
        <div className="statsBox">
          {siteContent.hero.highlights.map((item) => (
            <div className="statItem" key={item.value}>
              <h3>{item.value}</h3>
              <p>{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </>

  );
};

export default Hero;
